var extendBtn = document.querySelector('.extendedBtn');
extendBtn.addEventListener('click', function() {
  this.classList.toggle('rotate');
  var hash = extendBtn.previousElementSibling;
  if(extendBtn.classList.contains('rotate')){
    hash.classList.add('on');
  }else{
    hash.classList.remove('on');
  }
  
});

// collection/age-r 페이지만 260729
if (window.location.pathname.includes('/collections/age-r')) {
  document.body.classList.add('is-age-r-collection');
}